import { ref, Ref } from 'vue';
import {
    getSearch, ListHeaderItem, RequestData, SearchKey
} from '@/components/common/list';
import { staffAuthApi } from '@/api';
import router, { propertyBaseRouter, propertyOldCommunitySubRouter } from '@/router';

// search列表
const searchKeyList: SearchKey = [
    {
        name: 'Name',
        label: WordList.TabelPersonUserInHtmlName
    }, {
        name: 'Key',
        label: WordList.DeliveryRfCard
    }
];

const headers: Array<ListHeaderItem> = [
    {
        label: WordList.TabelPersonUserInHtmlName,
        name: 'Name'
    }, {
        label: WordList.DeliveryRfCard,
        name: 'Code'
    }, {
        label: WordList.ProperAllTextRepeats,
        name: 'Repeats'
    }, {
        label: WordList.TabelUpdateBoxDevice,
        name: 'DevicesText'
    }, {
        label: WordList.TabelMessageBoxCreateTime,
        name: 'CreateTime'
    }
];

const initRfCard = () => {
    // list请求借口及请求参数
    const requestData: Ref<RequestData> = ref({
        url: 'v3/web/community/key/getStaffRfCardListForOld',
        param: getSearch({
            searchKey: 'Name',
            searchValue: ''
        })
    });

    // list搜索查询处理
    const updateList = ref(0);
    const saveParamInPath = ref(false);
    const searchList = () => {
        updateList.value += 1;
        saveParamInPath.value = true;
    };
    const add = () => {
        router.push(`/${propertyBaseRouter}/${propertyOldCommunitySubRouter.oldSetStaffAuth}?opera=add`);
    };

    const edit = (val: object) => {
        localStorage.setItem('modifyKey', '1');
        localStorage.setItem('propertyKeyDetail', JSON.stringify(val));
        router.push(`/${propertyBaseRouter}/${propertyOldCommunitySubRouter.oldSetStaffAuth}?opera=edit`);
    };

    const download = () => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.download = 'Staff_RFCard_Template.xlsx';
        a.href = '/download/template/Staff_RFCard_Template.xlsx';
        a.click();
    };

    const totalCount = ref(0);
    const isShowDeleteDialog = ref(false);
    const deleteAll = (formData: {Password: string}) => {
        const params: {PassWd: string;Type: string} = {
            PassWd: hex_md5(formData.Password),
            Type: 'staffOrResidentDeleteAll'
        };
        staffAuthApi.deleteAllRfCard(params, () => {
            isShowDeleteDialog.value = false;
            updateList.value += 1;
        });
    };

    // 上传
    const file: Ref<any> = ref();
    const form: Ref<any> = ref();
    const setFile = () => {
        file.value.click();
    };
    const importRfCard = () => {
        const formData = new FormData(form.value);
        staffAuthApi.importRfCard(formData, () => {
            updateList.value += 1;
        });
        file.value.value = '';
    };

    return {
        searchKeyList,
        searchList,
        saveParamInPath,
        requestData,
        updateList,
        add,
        edit,
        importRfCard,
        deleteAll,
        download,
        headers,
        totalCount,
        isShowDeleteDialog,
        file,
        form,
        setFile
    };
};
export default initRfCard;
